import axios from "axios";
import _ from "lodash";

export default {
    methods: {
        getSoftware() {
            axios({
                method: 'get',
                url: '/programms/get_software',
            }).then((response) => {
                this.select_options.software = response.data.software;
                this.select_options.software = _.sortBy(this.select_options.software, 'name')
            }).catch((error) => {
                return error;
            });
        },
        getEduProg() {
            axios({
                method: 'get',
                url: '/programms/get_educational_programms',
            }).then((response) => {
                this.select_options.edu_progs = response.data.programs;
            }).catch((error) => {
                return error;
            });
        },
        getYears() {
            axios({
                method: 'get',
                url: '/programms/get_study_years',
            }).then((response) => {
                this.select_options.years = response.data.years;
            }).catch((error) => {
                return error;
            });
        },
        getEduProf(edu_prog_id) {
            $('#edu_prof').dropdown('restore defaults');
            axios({
                method: 'get',
                url: `/programms/get_edu_prof/${edu_prog_id}`,
            }).then((response) => {
                this.select_options.edu_profs = response.data.profiles;
            }).catch((error) => {
                return error;
            });
        },
        getCurriculum(edu_prog_id, year_id, edu_prof_id) {
            if ([384,321,70,347,313,71,314,316,348,330,315,73,389,74,75,76,382,77,385,78,355,357,354,356,360,377,379,359,358,364,361,362,363,382,424].includes(edu_prog_id)) {
                if (edu_prog_id !== 0 && year_id !== 0) {
                    $('#curriculum').dropdown('restore defaults');
                    axios({
                        method: 'get',
                        url: `/programms/get_curriculum/${edu_prog_id}/${year_id}`,
                    }).then((response) => {
                        this.select_options.curriculum = response.data.curriculum
                        this.programm.edu_prof = 1
                    }).catch((error) => {
                        return error;
                    });
                }
            }
            else {
                if (edu_prog_id !== 0 && year_id !== 0 && edu_prof_id !== "") {
                    $('#curriculum').dropdown('restore defaults');
                    axios({
                        method: 'get',
                        url: `/programms/get_curriculum/${edu_prog_id}/${year_id}/${edu_prof_id}`,
                    }).then((response) => {
                        this.select_options.curriculum = response.data.curriculum;
                    }).catch((error) => {
                        return error;
                    });
                }
            }
        },
        getDisciplines(curriculum_id) {
            if (curriculum_id !== ""){
                $('#discipline').dropdown('restore defaults');
                axios({
                    method: 'get',
                    url: `/programms/get_disciplines/${curriculum_id}`,
                }).then((response) => {
                    this.select_options.disciplines = response.data.disciplines;
                    this.getGraduatedDep(curriculum_id);
                }).catch((error) => {
                    return error;
                });
            }
        },
        getGraduatedDep(curriculum_id){
            axios({
                method: 'get',
                url: `/programms/get_grad_dep/${curriculum_id}`,
            }).then((response) => {
                this.select_options.departments = response.data.departments;
            }).catch((error) => {
                return error;
            });
        },
        getOverload(curriculum_id, discipline_id){
            axios({
                method: 'get',
                url: `/programms/get_overload/${curriculum_id}/${discipline_id}`,
            }).then((response) => {
                this.overload = response.data.overload;
                //this.main_info.creator.fio = response.data.fio;
                //this.main_info.creator.position = response.data.position;
                //this.main_info.creator.title = response.data.title;
                //if (this.main_info.speciality_code.split('.')[1] !== '02'){
                    //this.getControl();
                //}
                this.getTimes()
            }).catch((error) => {
                return error;
            });
        },
        current_software() {
            let array = []
            this.select_options.software.forEach(softer => {
                let result = _.find(this.software, function(n) {
                    if (n.info.id === softer.id) {
                        return true;
                    }
                })
                array.push(result)
            })
            this.software = array
        },
    }
}